const handleDeletePlaceModalPlaces = {
  confirmTrue: 'You cannot delete this place as it has ',
  true: 'equipment',
  false: 'sons',
  text: 'delete them before.',
  titleTrue: 'DELETE PLACE',
  confirmFalse: 'Do you really want to delete this place?',
  titleFalse: 'DELETE PLACE',
};

export default handleDeletePlaceModalPlaces;
